/* eslint-disable no-debugger */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line spaced-comment
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import clsx from "clsx";
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@material-ui/core";
import { MdReplay } from "react-icons/md";
import BackButton from "../../components/BackButton/BackButton";
import styles from "./AccessControlDelete.module.css";
import { CustomTab, Button } from "../../atomicComponents";
import UserInfo from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import {
  CustomFormGroup,
  ValidatingTextField
} from "../../components/FormComponents";

import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
// import WarningModal from "../../components/WarningModal/WarningModal";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import {
  MESSAGE_TYPE,
} from "../../constants";
import { setLogin } from '../../redux/features/auth/actions';
import Truckloading from "../../components/CvLoader/Cvloader";
import useDebounceSearch from "../../hooks/useDebounceSearch";
import { sanitizeNumeric } from "../../utils/utils";

function AccessControlDelete({ auth }) {
  const history = useHistory();

  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const redirectToProcessPage = () => {
    history.push("/home");
  };

  const [tableData, setTableData] = useState([]);
  const [dsTableData, setDSTableData] = useState([]);

  const [state, setState] = React.useState({
    linkageFlag: false,
    showTicketDetails: false,
    persNo: ""
  });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupOpen1, setIsPopupOpen1] = useState(false);
  const [deleteRow, setDeleteRow] = useState([]);
  const [projectCode, setProjectCode] = useState([]);
  const [roleSelected, setRoleSelected] = useState("");
  const [empDetails, setEmpDetails] = useState([]);
  const [linkageDetails, setLinkageDetails] = useState([]);
  const [selectedRole, setSelectedRole] = useState({});
  const [showTicketDetails, setShowTicketDetails] = useState(false);
  const [showLiBc, setShowLiBc] = useState(false);
  const [showBc, setShowBc] = useState(false);
  const [showDS, setShowDS] = useState(false);
  const { showPopup } = usePopupManager();
  const [checkedradio, setRadioChecked] = useState(false);
  const [showSup, setShowSup] = useState(false);
  const [showSA, setShowSA] = useState(false);
  const dispatchNew = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const searchByTicket = useDebounceSearch(state.persNo)
  const [NewRole, setNewRole] = useState({
    roles: [],
  });

  useEffect(() => {
    if (showBc || showSA || showDS || showLiBc || showSup === true) {
      setBtnDisable(false);
    } else {
      setBtnDisable(true);
    }
  }, [showBc, showSA, showDS, showLiBc, showSup]);



  const handleChangesLI = (e) => {
    // Destructuring
    const { checked, value } = e.target;
    const { roles } = NewRole;

    if (checked) {
      setNewRole({
        roles: [...roles, value],

      });

      setShowLiBc(true)
      if (linkageDetails.length === 0) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Data Not Found"
        });
      }
    }
    // Case 2  : The user unchecks the box
    else {
      setNewRole({
        roles: roles.filter((e) => e !== value),

      });
      setShowLiBc(false);
    }
  };


  const handleChanges = (e) => {
    // Destructuring
    const { checked, value } = e.target;
    const { roles } = NewRole;
    // Case 1 : The user checks the box
    if (checked) {
      setNewRole({
        roles: [...roles, value],

      });
      setShowBc(true)
    }

    // Case 2  : The user unchecks the box
    else {
      setNewRole({
        roles: roles.filter((e) => e !== value),

      });
      setShowBc(false);
    }
    if (checked) {

      if (tableData.length === 0) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Data Not Found"
        });
      }
    }


    // Case 2  : The user unchecks the box
    else {
      setShowBc(false)   
    }
  };

  const handleChangesSup = (e) => {
    // Destructuring
    const { checked, value } = e.target;
    const { roles } = NewRole;
    if (checked) {
      setNewRole({
        roles: [...roles, value],

      });
    }
    // Case 2  : The user unchecks the box
    else {
      setNewRole({
        roles: roles.filter((e) => e !== value),

      });
    }

    if (checked) {
      setShowSup(true)
    }
    // Case 2  : The user unchecks the box
    else {
      setShowSup(false)
    }
  };
  const handleChangesSA = (e) => {
    // Destructuring
    const { checked, value } = e.target;
    const { roles } = NewRole;
    if (checked) {
      setNewRole({
        roles: [...roles, value],

      });
      setShowSA(true);
    }

    // Case 2  : The user unchecks the box
    else {
      setNewRole({
        roles: roles.filter((e) => e !== value),

      });
      setShowSA(false);
    }
    

  };

  const handleChangesDS = (e) => {
    // Destructuring
    const { checked, value } = e.target;
    const { roles } = NewRole;
    if (checked) {
      setNewRole({
        roles: [...roles, value],
      });
    }
    // Case 2  : The user unchecks the box
    else {
      setNewRole({
        roles: roles.filter((e) => e !== value),
      });
    }
    // Case 1 : The user checks the box
    if (checked) {
      setShowDS(true);
      if (dsTableData.length === 0) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Data Not Found"
        });
      }
    }
    // Case 2  : The user unchecks the box
    else {     
      setShowDS(false)
    }

  };

  const getEmployeeDetails = () => {
    try {
      setLoading(true)
      let apiFormatedData = {
        pers_no: sanitizeNumeric(state.persNo)
      };
      var apiFormatedDataJson = JSON.stringify(apiFormatedData);
      let headerss = new Headers();
      headerss.append("Content-Type", "application/json");
      fetch(`${baseUrl}master/displaydeldetails`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          dispatchNew(setLogin({ ...auth, recentStatus: response.status }))
          return response.json();
        })
        .then((responseJson) => {
          setLoading(false)
          let lowercaseMsg = responseJson.msg.toLowerCase();
          if (lowercaseMsg === "success") {
            setLoading(false)
            setNewRole((prev) => ({
              ...prev,
              roles: []
            }))
            if (responseJson.data["user_details"][0] === undefined) {
              showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "Please enter valid Person number"
              });
            }

            setEmpDetails(responseJson.data["user_details"][0]);

            let roleData = responseJson.data["user_details"][0]?.roles
              .split(",")
              ?.map((item) => item);
            if (roleData.includes("LI")) {
              setLinkageDetails(responseJson.data["linkage_dets"]);
            }
            if (roleData.includes("B")) {
              setTableData(responseJson.data["bc_head_dets"]);
            } if (roleData.includes("DS")) {
              setDSTableData(responseJson.data["dept_spoc_bc"]);
            }
            setSelectedRole(roleData);
            if (responseJson.data["user_details"][0].person_no !== "") {
              setShowTicketDetails(true);
            }
            if (responseJson.data["user_details"][0].roles !== "") {
              setShowTicketDetails(true);
            }
          }
          else if (lowercaseMsg === "fail") {
            setLoading(false)
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: responseJson.data
            });
          }
        })
    }
    catch (error) {
      setLoading(false)
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: "Oops! Something went wrong. Please try again later."
      });
    }
  };
  useEffect(() => {
    if (searchByTicket) {
      getEmployeeDetails();
    } else {
      setShowTicketDetails(false);
      setRoleSelected({});
      setEmpDetails([]);
      setShowBc(false);
      setShowLiBc(false);
    }
  }, [searchByTicket]);

  const handleOpen = () => setIsPopupOpen(true);
  const handleClose = () => setIsPopupOpen(false);

  const handleOpen1 = () => {
    setIsPopupOpen1(true);
  };

  const handleClose1 = () => setIsPopupOpen1(false);

  const handleKeyPress = (event) => {
    const keyCode = event.charCode;
    // Check if the entered character is a numeric character (0-9)
    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
  };

  const onChangeInput = (event) => {
    const { name, value } = event.target;
    setState((prevData) => ({
      ...prevData,
      [name]: value.trim()
    }));
  };

  const handleCheckboxLinkage = (rowId, projectcde, info) => {
    const deleteCheck = deleteRow.includes(rowId);
    const projCheck = projectCode.includes(projectcde);

    if (deleteCheck) {
      setDeleteRow(deleteRow.filter((id) => id !== rowId));
    } if (deleteCheck) {
      setDeleteRow(deleteRow.filter((id) => id == rowId));
    }
    else {
      setDeleteRow([...deleteRow, rowId]);
    }
    if (projCheck) {
      setProjectCode(projectCode.filter((id) => id !== projectcde));
    }
    if (projCheck) {
      setProjectCode(projectCode.filter((id) => id == projectcde));
    }
    else {
      setProjectCode([...projectCode, projectcde]);
    }
  };
  const handleCheckboxBcHead = (rowId, projectcde) => {
    const deleteCheck = deleteRow.includes(rowId);
    if (deleteCheck) {
      setDeleteRow(deleteRow.filter((id) => id !== rowId));
    } else {
      setDeleteRow([...deleteRow, rowId]);
    }
  };

  const handleDeleteRows = () => {
   
  };

  const resetFields = () => { };
  const handleReset = () => {
    setState((prevData) => ({
      ...prevData,
      linkageFlag: false,
      persNo: ""
    }));
    setShowTicketDetails(false);
    setTableData([]);
    setNewRole((prev) => ({
      ...prev,
      roles: []
    }))
    setShowBc(false);
    setShowLiBc(false);
    setShowDS(false);
    setShowSA(false);
    setShowSup(false);
    setIsPopupOpen(false);
    setIsPopupOpen1(false);
    setDeleteRow([]);
    setShowBc(false);
    setShowLiBc(false);
  };

  const renderHTML = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2} sm={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Employee Details </label>
            </div>
          </div>
        </Grid>
        {loading == true ?
          <div style={{ textAlign: "center", display: "flex", justifyContent: "center", marginTop: "10px", background: "white", boxShadow: "0px 3px 6px #00000027" }}>
            <Truckloading />
          </div>
          : (
            <Grid item md={5} lg={5} xs={5} sm={10}>
              <div className={styles.formDiv}>
                <TableSimple
                  tableColumnData={[
                    {
                      ticket: (
                        <ValidatingTextField
                          variant="outlined"
                          size="small"
                          name="persNo"
                          isDisabled={false}
                          value={state.persNo}
                          inputProps={{
                            "data-testid": "remark-input"
                          }}
                          onChange={onChangeInput}                      
                          style={{ width: "100%" }}
                        />
                      ),
                      empName: empDetails?.employee_name,
                      costCentre: empDetails?.cost_center
                    }
                  ]}
                  tableHeaderLabel={[
                    "Person No_30",
                    "Employee Name_40",
                    "Cost Centre_20"
                  ]}
                  TableRowHederAling="start"
                  size="small"
                  headerColor="#E6F2FF"
                  className="custom-table"
                />
              </div>
            </Grid>
          )}

      </Grid>
    </div>
  );



  const handleDeleteTable = () => {
    try {
      setLoading(true);
      let apiFormatedData = {};
      // console.log(projectCode,"projectCode definition")
      if (showLiBc) {
        apiFormatedData = {
          pers_no: sanitizeNumeric(state.persNo),
          role: "LI",
          user_id: sanitizeNumeric(auth.personNumber),
          project_def_param: projectCode.map((data) => data).join(","),
          // bc_no_param: "0005119372"
          bc_no_param: deleteRow.map((data) => data).join(",")
        };
      }
      if (showBc) {
        apiFormatedData = {
          pers_no: sanitizeNumeric(state.persNo),
          role: "B",
          user_id: sanitizeNumeric(auth.personNumber),
          project_def_param: "",
          bc_no_param: deleteRow.map((data) => data).join(",")
        };
      }
      if (showDS) {
        apiFormatedData = {
          pers_no: sanitizeNumeric(state.persNo),
          role: "DS",
          user_id: sanitizeNumeric(auth.personNumber),
          project_def_param: "",
          bc_no_param: deleteRow.map((data) => data).join(",")
        };
      }

      var apiFormatedDataJson = JSON.stringify(apiFormatedData);
      let headerss = new Headers();
      headerss.append("Content-Type", "application/json");
      fetch(`${baseUrl}master/deleteuserroleselective`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          dispatchNew(setLogin({ ...auth, recentStatus: response.status }))
          return response.json();
        })
        .then((responseJson) => {
          setLoading(false);
          let lowercaseMsg = responseJson.msg.toLowerCase();
          if (lowercaseMsg === "success") {
            setLoading(false);     
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: "Deleted successfully",
              reloads:true, // Set reload to true or false based on your condition
            });
          } else {
            setLoading(false);
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: responseJson.msg,
            })
          }
          if (lowercaseMsg === "fail") {
            setLoading(false);
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: responseJson.data,
            })
          }
        });
    }
    catch (error) {
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: "Oops! Something went wrong. Please try again later.",
      })
    }
  };
  // console.log(tableData,'tableData')
  const renderReport = () => (
    <>
      <div className={styles.formGroup}>
        <Grid
          container
          spacing={1}
          className={styles.myGrid}
          style={{ marginTop: "10px" }}
          columns={12}
        >
          <Grid
            item
            md={7}
            lg={7}
            sm={8}
            style={{
              padding: "0px",
              marginTop: "10px",
              marginBottom: "10px"
            }}
          >
            <div className={styles.rowDiv}>
              <span style={{ marginRight: "27px" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="BC"
                  value="B"
                  id="BC_Head"
                  checked={showBc}
                  disabled={!selectedRole.includes("B")}
                  onChange={handleChanges}
                  style={{ cursor: 'pointer' }}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  BC Head
                </label>
              </span>
              <span style={{ marginRight: "30px" }}>
                <input
                  className="form-check-input2"
                  type="checkbox"
                  name="SA"
                  value="SA"
                  id="SA_Head"
                  checked={showSA}
                  disabled={!selectedRole.includes("SA")}
                  onChange={handleChangesSA}
                  style={{ cursor: 'pointer' }}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Super Admin
                </label>
              </span>
              <span style={{ marginRight: "30px" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="DS"
                  value="DS"
                  id="DS_Head"
                  checked={showDS}
                  disabled={!selectedRole.includes("DS")}
                  onChange={handleChangesDS}
                  style={{ cursor: 'pointer' }}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Department SPOC
                </label>
              </span>
              <span style={{ marginRight: "30px" }}>
                <input
                  className="form-check-input4"
                  type="checkbox"
                  name="LI"
                  value="LI"
                  id="LI_Head"
                  checked={showLiBc}
                  disabled={!selectedRole.includes("LI")}
                  onChange={handleChangesLI}
                  style={{ cursor: 'pointer' }}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Linkage SPOC
                </label>

              </span>
              <span style={{ marginRight: "30px" }}>
                <input
                  className="form-check-input5"
                  type="checkbox"
                  name="SUP"
                  value="S"
                  id="Supervisor"
                  checked={showSup}
                  disabled={!selectedRole.includes("S")}
                  onChange={handleChangesSup}
                  style={{ cursor: 'pointer' }}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Supervisor
                </label>

              </span>
            </div>
          </Grid>
          <Grid
            item
            md={3}
            lg={3}
            sm={3}
            style={{
              padding: "0px",
              marginTop: "10px",
              marginBottom: "10px"
            }}
          >
            <div className={styles.rowDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                disabled={btnDisable}
                variant="primary"
                // onClick={handleDeleteRole}
                onClick={handleOpen}
                data-testid="confirm-actions"
                style={{ marginRight: "5px", marginLeft: "15px" }}
              >
                Delete role
              </Button>
              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="primary"
                onClick={handleReset}
                data-testid="confirm-action"
                style={{ marginRight: "5px", marginLeft: "15px" }}
              >
                Cancel
              </Button>         
            </div>
          </Grid>
        </Grid>
      </div>

      <div className={styles.formGroup}>
        <Grid
          item
          md={12}
          lg={12}
          sm={2}
          xs={12}
          style={{ marginBottom: "20px" }}
        >
          {showLiBc && linkageDetails.length !== 0 && (
            <>
              <Grid
                container
                spacing={1}
                // className={styles.myGrid}
                style={{ marginTop: "10px" }}
                columns={12}
              >
                <Grid item md={2} lg={2} xs={2} sm={2}>
                  <div className={styles.rowDiv}>
                    <div className={clsx(styles.lableDiv2)}>
                      <label>Linkage BC-Project Details</label>
                      {/* {showBc && <label>BC Head Details</label>} */}
                    </div>
                  </div>
                </Grid>

                <Grid item md={8} lg={8} xs={8} sm={10}>

                  {/* <div className={styles.rowDiv}> */}
                  <div className={styles.formDiv}>
                    <TableSimple
                      tableColumnData={linkageDetails?.map((info, index) => ({
                        bcNo: info.bc_no,
                        bcName: info.code_desc,
                        projectCode: info.project_def,
                        projectDescription: info.project_desc,
                        select: (
                          <input
                            type="checkbox"                       
                            onChange={(e) =>
                              handleCheckboxLinkage(info.bc_no, info.project_def, info)
                            }
                          />
                        )
                      }))}
                      tableHeaderLabel={[
                        "Bc No_40",
                        "Bc Name_60",
                        "Project Code_40",
                        "Project Description_110",
                        "Delete_25"
                      ]}
                      TableRowHederAling="start"
                      size="small"
                      headerColor="#E6F2FF"
                      className="custom-table"
                    ></TableSimple>
                  </div>             
                </Grid>
                <Grid
                  container
                  spacing={1}
                  style={{ marginTop: "10px" }}
                  columns={12}
                >
                  <Grid item md={6} lg={6} sm={12}>
                    <Button
                      className={clsx(
                        styles.actionButton,
                        styles.primaryActionButton
                      )}
                      variant="primary"               
                      onClick={handleDeleteTable}
                      data-testid="confirm-action"
                      style={{
                        marginRight: "5px",
                        marginLeft: "15px",
                        marginTop: "10px"
                      }}
                    >
                      Delete
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
          {showBc && tableData.length !== 0 && (

            <>
              <Grid
                container
                spacing={1}       
                style={{ marginTop: "10px" }}
                columns={12}
              >
                <Grid item md={2} lg={2} xs={2} sm={2}>
                  <div className={styles.rowDiv}>
                    <div className={clsx(styles.lableDiv2)}>
                      <label>BC Head Details</label>
                    </div>
                  </div>
                </Grid>
                <Grid item md={8} lg={8} xs={8} sm={10}>
                  <div className={styles.formDiv}>
                    <TableSimple
                      tableColumnData={tableData?.map((info, index) => ({
                        bcNo: info.bc_no,
                        bcName: info.code_desc,
                        selection: (
                          <input
                            type="checkbox"                     
                            onChange={(e) =>
                              handleCheckboxBcHead(
                                info.bc_no,
                                info.code_desc
                              )
                            }
                          />
                        )
                      }))}
                      tableHeaderLabel={["Bc No_40", "Bc Name_130", "Delete_50"]}
                      TableRowHederAling="start"
                      size="small"
                      headerColor="#E6F2FF"
                      className="custom-table"
                    ></TableSimple>
                  </div>
                </Grid>
                <Grid
                  container
                  spacing={1}               
                  style={{ marginTop: "10px" }}
                  columns={12}
                >
                  <Grid item md={6} lg={6} sm={12}>
                    <Button
                      className={clsx(
                        styles.actionButton,
                        styles.primaryActionButton
                      )}
                      variant="primary"
                      onClick={handleDeleteTable}
                      data-testid="confirm-action"
                      style={{
                        marginRight: "5px",
                        marginLeft: "15px",
                        marginTop: "10px"
                      }}
                    >
                      Delete
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
          {showDS && dsTableData.length !== 0 && (
            <>
              <Grid
                container
                spacing={1}             
                style={{ marginTop: "10px" }}
                columns={12}
              >
                <Grid item md={2} lg={2} xs={2} sm={2}>
                  <div className={styles.rowDiv}>
                    <div className={clsx(styles.lableDiv2)}>
                      <label>Departmental SPOC</label>
                    </div>
                  </div>
                </Grid>
                <Grid item md={8} lg={8} xs={8} sm={10}>
                  <div className={styles.formDiv}>
                    <TableSimple
                      tableColumnData={dsTableData?.map((info, index) => ({
                        bcNo: info.bc_no,
                        bcName: info.code_desc,
                        selection: (
                          <input
                            type="checkbox"                     
                            onChange={(e) =>
                              handleCheckboxBcHead(
                                info.bc_no,
                                info.code_desc
                              )
                            }
                          />
                        )
                      }))}
                      tableHeaderLabel={["Bc No_40", "Code Description_130", "Delete_50"]}
                      TableRowHederAling="start"
                      size="small"

                      headerColor="#E6F2FF"
                      className="custom-table"
                    ></TableSimple>
                  </div>
                </Grid>
                <Grid
                  container
                  spacing={1}              
                  style={{ marginTop: "10px" }}
                  columns={12}
                >
                  <Grid item md={6} lg={6} sm={12}>
                    <Button
                      className={clsx(
                        styles.actionButton,
                        styles.primaryActionButton
                      )}
                      variant="primary"
                      onClick={handleDeleteTable}
                      data-testid="confirm-action"
                      style={{
                        marginRight: "5px",
                        marginLeft: "15px",
                        marginTop: "10px"
                      }}
                    >
                      Delete
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </div>
    </>
  );

  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
        <div
          className={styles.backButtonLastRefreshedDateWrapper}
          style={{ display: "none" }}
        >
          <BackButton action="Home" handleClick={redirectToProcessPage} />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab
              title="Delete Access And Role Control"
              withOutCount
              isSelected
            />
          </div>
          <div className={styles.processTopbar} style={{}}>
            <UserInfo
              userInfo={[
                {
                  Name: "Priya Kumari",
                  "SAP ID": 122367,
                  "BC No": "122366",
                  LOC: "Engineering and Research Center"
                }
              ]}
            />
          </div>
        </div>
        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
          style={{ height: "82vh" }}
        >
          <CustomFormGroup
            header="Delete Access And Role Control"
            body={renderHTML()}
          />
          {showTicketDetails && renderReport()}
        </div>      
        <ResetModal
          isPopupOpen={isPopupOpen}
          handleClose={handleClose}
          resetFields={resetFields}
          baseUrl={baseUrl}
          state={state}
          userRole={NewRole}
          auth={auth}
          dispatchNew={dispatchNew}
        />
        <ResetModal1
          isPopupOpen1={isPopupOpen1}
          handleClose1={handleClose1}
          resetFields={resetFields}
          handleDeleteRows={handleDeleteRows}
          dispatchNew={dispatchNew}
        />
      </div>
    </>
  );
}

function ResetModal({ isPopupOpen, handleClose, resetFields, baseUrl, state, userRole, auth }) {
  const dispatchNew = useDispatch();
  const { showPopup } = usePopupManager();

  const [deleteMessage, setDeleteMessage] = useState("")

  const handleDeleteRole = () => {
    try {
      let apiFormatedData = {
        pers_no: sanitizeNumeric(state.persNo),
        role: userRole.roles.join(","),
        user_id: sanitizeNumeric(auth.personNumber)
      };
      var apiFormatedDataJson = JSON.stringify(apiFormatedData);
      let headerss = new Headers();
      headerss.append('X-Session-Id', sessionId)
      headerss.append("Content-Type", "application/json");
      fetch(`${baseUrl}master/deleteUserAccessAll`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:"include"
      })
        .then((response) => {
          dispatchNew(setLogin({ ...auth, recentStatus: response.status }))
          return response.json();
        })
        .then((responseJson) => {
          let lowercaseMsg = responseJson.msg.toLowerCase();
          if (lowercaseMsg == "success") {
            setDeleteMessage(responseJson.data)
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: responseJson.data,
              reloads: true
            })

          }
          else if (lowercaseMsg == "fail") {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: responseJson.data,
            })
          }
        })

    }
    catch (error) {
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: "Oops! Something went wrong. Please try again later.",
      })
    }



  };
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Confirm</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Are you sure you want to Delete the role</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleDeleteRole();
              handleClose();
              resetFields();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal1({
  isPopupOpen1,
  handleClose1,
  resetFields,
  handleDeleteRows
}) {
  return (
    <Dialog
      open={isPopupOpen1}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox
      }}
      data-testid="delete-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Confirm</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Are you sure you want to Delete the data</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose1}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              handleDeleteRows();
              e.preventDefault();
              handleClose1();
              resetFields();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired
};

ResetModal1.propTypes = {
  isPopupOpen1: PropTypes.bool.isRequired,
  handleClose1: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({});
AccessControlDelete.propTypes = {
  product: PropTypes.object
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccessControlDelete);